module.exports = __webpack_public_path__ + "img/point.b756cdf9.png";